import { render, staticRenderFns } from "./HomeSynthesizeSupervise.vue?vue&type=template&id=1fcfd10d&scoped=true&"
import script from "./HomeSynthesizeSupervise.vue?vue&type=script&lang=js&"
export * from "./HomeSynthesizeSupervise.vue?vue&type=script&lang=js&"
import style0 from "./HomeSynthesizeSupervise.vue?vue&type=style&index=0&id=1fcfd10d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcfd10d",
  null
  
)

export default component.exports